import { REQUEST } from 'actions/utils';
import {
  getProforientationRecommendationApplications,
  getProforientationRecommendationEvents,
  getProforientationResults,
  postProforientationEventApplication,
} from 'api';
import { ApiResult } from 'api/impl';
import {
  IProfessionProforientationData,
  IProfessionProforientationResponse,
  IProforientaitonRecommendationEvents,
  IProforientationRecommendatonApplications,
  IResponsePayload,
} from 'api/types';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { toast } from 'portfolio3/ui-kit';
import { IRootState } from 'reducers';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import store from 'store';
import { isDefined } from 'utils';

import {
  GET_PROFORIENTATION,
  GET_PROFORIENTATION_RECOMMENDATION_APPLICATIONS,
  GET_PROFORIENTATION_RECOMMENDATION_EVENTS,
  getProforientationActions,
  getProforientationRecommendationApplicationsActions,
  getProforientationRecommendationEventsActions,
  POST_PROFORIENTATION_EVENT_APPLICATION,
  postProforientationEventApplicationActions,
} from './actions';

type GetProforientationResult = ApiResult<IProfessionProforientationResponse<IProfessionProforientationData>, unknown>;
type GetProforientationRecommendationEventsResult = ApiResult<
  IResponsePayload<IProforientaitonRecommendationEvents>,
  unknown
>;
type GetProforientationRecommendationApplicationsResult = ApiResult<
  IResponsePayload<IProforientationRecommendatonApplications>,
  unknown
>;

export const collection = [
  watchGetProforientation,
  watchGetProforientationRecommendationEvents,
  watchGetProforientationRecommendationApplications,
  watchPostProforientationEventApplication,
].map(fork);

function* watchGetProforientation() {
  yield takeLatest(GET_PROFORIENTATION[REQUEST], getProforientationResultsSaga);
}

function* watchGetProforientationRecommendationEvents() {
  yield takeLatest(GET_PROFORIENTATION_RECOMMENDATION_EVENTS[REQUEST], getProforientationRecommendationEventsSaga);
}

function* watchGetProforientationRecommendationApplications() {
  yield takeLatest(
    GET_PROFORIENTATION_RECOMMENDATION_APPLICATIONS[REQUEST],
    getProforientationRecommendationApplicationsSaga,
  );
}

function* watchPostProforientationEventApplication() {
  yield takeLatest(POST_PROFORIENTATION_EVENT_APPLICATION[REQUEST], postProforientationEventApplicationSaga);
}

function* getProforientationResultsSaga({ payload }: ReturnType<typeof getProforientationActions.request>) {
  const { personId } = payload;

  const { response, error }: GetProforientationResult = yield call(getProforientationResults, personId);

  if (isDefined(response)) {
    yield put(getProforientationActions.success(response));
  } else {
    yield put(getProforientationActions.failure(error));
  }
}

function* getProforientationRecommendationEventsSaga({
  payload,
}: ReturnType<typeof getProforientationRecommendationEventsActions.request>) {
  const { personId, classLevel } = payload;

  const { response, error }: GetProforientationRecommendationEventsResult = yield call(
    getProforientationRecommendationEvents,
    personId,
    classLevel,
  );

  if (isDefined(response)) {
    yield put(getProforientationRecommendationEventsActions.success(response));
  } else {
    yield put(getProforientationRecommendationEventsActions.failure(error));
  }
}

function* getProforientationRecommendationApplicationsSaga({
  payload,
}: ReturnType<typeof getProforientationRecommendationApplicationsActions.request>) {
  const { personId } = payload;

  const { response, error }: GetProforientationRecommendationApplicationsResult = yield call(
    getProforientationRecommendationApplications,
    personId,
  );

  if (isDefined(response)) {
    yield put(getProforientationRecommendationApplicationsActions.success(response));
  } else {
    yield put(getProforientationRecommendationApplicationsActions.failure(error));
  }
}

function* postProforientationEventApplicationSaga({
  payload,
}: ReturnType<typeof postProforientationEventApplicationActions.request>) {
  const { personId, eventId } = payload;

  const { response, error } = yield call(postProforientationEventApplication, personId, eventId);

  if (isDefined(error) || response?.result === 'FAIL') {
    yield put(postProforientationEventApplicationActions.failure(error));
    const reponseMessage = response?.message ?? 'Не удалось отправить заявку';
    toast.error(reponseMessage);
    emitYMEvent({
      type: 'confirmParticipation_error',
      payload: {
        error: error ? `${error.error ? error.error + ': ' : ''}${error.message}` : reponseMessage,
      },
    });
  } else {
    yield put(postProforientationEventApplicationActions.success(null));
    toast.success('Заявка на участие отправлена');
    emitYMEvent({
      type: 'confirmParticipation_success',
    });

    const state: IRootState = store.getState();
    const classLevel = state.currentStudent.classLevel;

    // получаем актуальные данные
    yield put(getProforientationRecommendationApplicationsActions.request(personId));
    yield put(getProforientationRecommendationEventsActions.request(personId, Number(classLevel)));
  }
}
